import * as React from 'react'

type Props = {
  title: string
  description: string
}

export default function SuccessMessage({ title, description }: Props) {
  return (
    <div className="root">
      <svg
        width="173"
        height="161"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28.459 60.171c-8.98 32.633.997 28.282 27.94 63.09 6.984 6.526 7.483 29.913 30.933 10.877 23.449-19.035 43.905-8.158 59.87-27.193 15.966-19.036 7.983-26.106-22.451-66.353C94.317.345 37.439 27.539 28.459 60.172z"
          fill="#3AC389"
        />
        <path
          d="M48.46 53.146c5.746-29.812 44.352-29.22 74.877-27.977 17.405.71 18.78 6.017 18.583 55.907-.197 49.889-59.656 58.527-88.21 50.928-28.555-7.599-38.252-26.487-19.742-38.378 18.51-11.891 8.744-10.668 14.491-40.48z"
          fill="#39E59D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M60.655 85.293c-1.512-1.657 1.443-5.054 3.645-3.405l12.728 9.531 24.537-31.758c2.262-2.927 5.698.14 4.386 2.045l-28.733 41.746-16.563-18.159z"
          fill="#fff"
        />
      </svg>

      <h2>{title}</h2>

      <div className="description">{description}</div>

      <style jsx>{`
        .root {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          text-align: center;
        }

        h2 {
          margin: 0 0 23px 0;

          font-weight: bold;
          font-size: 36px;

          line-height: 42px;
        }

        .description {
          line-height: 30px;
          font-size: 20px;

          color: #57607b;
        }
      `}</style>
    </div>
  )
}
